import ArrowIcon from '@assets/icons/arrow.svg?react'

import s from './BackButton.module.scss'
import type { BackButtonProps } from './BackButton.props'

export function BackButton({ onClick }: BackButtonProps) {
  return (
    <button
      className={s.btn}
      onClick={onClick}
    >
      <ArrowIcon />
      <span className={s.text}>Back</span>
    </button>
  )
}
